import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useReportAuth } from '../context/ReportAuthContext';
import { fetchReport, downloadCertificate } from '../services/api';

function fmt(val) {
  //console.log('report fmt() help me');
  return val || '—';
}

function CheckResult({ label, status, detail }) {
  //console.log('Report.jsx - function CheckResult({ label, status, detail }) {');
  const pass = status === 'CLEAR' || status === 'PASS' || status === true;
  return (
    <div className={`check-result check-result-${pass ? 'pass' : 'fail'}`}>
      <div className="check-icon">
        <i className={`fas fa-${pass ? 'check' : 'times'}-circle`}></i>
      </div>
      <div className="check-content">
        <h4>{label} — {pass ? 'CLEAR' : 'ALERT'}</h4>
        <p>{detail || (pass ? 'No issues found' : 'Issues detected – review the full report')}</p>
      </div>
    </div>
  );
}

export default function Report() {
  //console.log('Report.jsx - export default function Report() {');
  const navigate = useNavigate();
  //console.log('Report.jsx - const navigate = useNavigate();');
  const { reportToken, orderId, clearSession } = useReportAuth();

  const [order,       setOrder]       = useState(null);
  const [loading,     setLoading]     = useState(true);
  const [error,       setError]       = useState('');
  const [downloading, setDownloading] = useState(false);
  const [pprstransactionid, setPPRStransactionid]  = useState('');
  //console.log('Report.jsx - 62 report page help me');

  const loadReport = useCallback(async () => {
    try {
      //console.log('token: ' + reportToken);
      //console.log('Report.jsx - const loadReport = useCallback(async () => {');
      const data = await fetchReport(reportToken);
      //console.log('Report.jsx - const data = await fetchReport(reportToken);');
      setOrder(data);
      //console.log('Report.jsx - setOrder(data);: ' + JSON.stringify(data));
      console.log('Report.jsx - setOrder(data);: ' + JSON.stringify(data));
      setPPRStransactionid(data?.reportData?.id || '');
      //console.log('Report.jsx - setPPRStransactionid(data?.reportData?.id || \'\');: ' + (data?.reportData?.id || ''));

      //console.log('65 data loaded successfully');

    } catch (err) {
      if (err.response?.status === 401) {
        //console.log('64 error loading report: invalid or expired token');
        // Token invalid/expired — clear session and redirect
        clearSession();
        navigate('/', { replace: true });
      } else {
        setError(err.response?.data?.error || 'Failed to load report. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  useEffect(() => {
    
    loadReport();

    const const_session_hasdownloaded = sessionStorage.getItem('session_hasdownloaded');

    if(const_session_hasdownloaded === null) {
        handleDownloadPDF();
        sessionStorage.setItem('session_hasdownloaded', 'yes');
        console.log('PPSR certificate has downloaded successfully');
      }

  }, [loadReport]);

  async function handleDownloadPDF() {
    //console.log('Report.jsx - async function handleDownloadPDF() {');
    setDownloading(true);
    try {
      //console.log('BEFORE: Report.jsx - const blob = await downloadCertificate(reportToken);');
      
      let base64 = '';
      let certificateFileName = '';

      const certificateFileDataStored = sessionStorage.getItem('certificateFileData');
      const certificateFileNameStored = sessionStorage.getItem('certificateFileName');

      if(certificateFileDataStored === null || certificateFileNameStored === null) {
        const downloadCertificate_result = await downloadCertificate(reportToken, pprstransactionid);
      
        base64 = downloadCertificate_result.data.certificateFileData;
        certificateFileName = downloadCertificate_result.data.certificateFileName;

        sessionStorage.setItem('certificateFileData', base64);
        sessionStorage.setItem('certificateFileName', certificateFileName);
      }
      else
      {
        base64 = certificateFileDataStored;
        certificateFileName = certificateFileNameStored;
      }


    // Handle possible prefix
    if (base64.includes(',')) {
        base64 = base64.split(',')[1];
    }

    // Decode Base64
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    // Create PDF Blob
    const blob = new Blob([byteArray], { type: 'application/pdf' });

    // Download file
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = certificateFileName || 'certificate.pdf';

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);









      // ✅ Sanity check - make sure we got a real Blob
    //if (!(blob instanceof Blob)) {
      //console.log('if (!(blob instanceof Blob)) {');
      //throw new Error('Invalid response: expected a file download');
    //}

      //console.log('AFTER: Report.jsx - const blob = await downloadCertificate(reportToken);');
      ////console.log('Report.jsx - blob: ' + JSON.stringify(blob));
      ////const blob = ''; // Placeholder since downloadCertificate is not implemented
      ////const blob = await res.blob();
      //const url  = URL.createObjectURL(blob);
      //const a    = document.createElement('a');
      //a.href     = url;
      ////a.download = `PPSR_Certificate_${order?.plate || orderId}.pdf`;
      //a.download = `PPSR_Certificate_${pprstransactionid || 'download'}.pdf`;;
      //document.body.appendChild(a);
      //a.click();
      //document.body.removeChild(a);
      //window.URL.revokeObjectURL(url);


    } catch (err) {
      console.log(err.message || 'Download failed. Please try again.');
    } finally {
      setDownloading(false);
    }
  }

  function handlePrint() {
    console.log('handlePrint() help me');
    window.print();
  }

  if (loading) {
    return (
      <>
        <Header />
        <div className="loading-screen">
          <i className="fas fa-spinner fa-spin fa-3x"></i>
          <p>Loading your report…</p>
        </div>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header />
        <div className="error-screen">
          <i className="fas fa-exclamation-circle fa-3x"></i>
          <h2>Report Unavailable</h2>
          <p>{error}</p>
          <button className="btn btn-primary" onClick={() => navigate('/')}>Return Home</button>
        </div>
        <Footer />
      </>
    );
  }

  const reportData = order?.reportData || {};
  const now        = new Date();
  const dateStr    = now.toLocaleDateString('en-AU', { day: '2-digit', month: '2-digit', year: 'numeric' });
  const timeStr    = now.toLocaleTimeString('en-AU', { hour: '2-digit', minute: '2-digit' });

  // Normalise API response fields (the InfoAgent API may use different casing)
  const vehicle = reportData?.vehicle || reportData?.vehicleDetails || {};
  const ppsr    = reportData?.ppsr    || reportData?.ppsrDetails    || {};
  const rego    = reportData?.registration || {};
   
  const [complianceyear, compliancemonth] = order?.reportData?.result?.vehicle?.details?.compliancePlate ? order?.reportData?.result?.vehicle?.details?.compliancePlate.split("-") : [];
  const compliancedate = `${compliancemonth} / ${complianceyear}`;
  return (
    <>
      <Header />

      {/* Success Banner */}
      <section className="success-banner">
        <div className="container">
          <div className="success-content">
            <div className="success-icon"><i className="fas fa-check-circle"></i></div>
            <div className="success-message">
              <h1>Payment Successful!</h1>
              <p>Your PPSR report has been generated and is ready to download. A copy has also been sent to your email.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Actions Bar */}
      <section className="report-actions-bar">
        <div className="container">
          <div className="report-actions-content">
            <div className="report-info">
              <strong>Order ID:</strong> <span>{order.orderId}</span>
              <span className="separator">|</span>
              <strong>Date:</strong> <span>{dateStr}</span>
            </div>
            <div className="report-buttons">
              <button
                className="btn btn-primary"
                onClick={handleDownloadPDF}
                disabled={downloading}
              >
                {downloading
                  ? <><i className="fas fa-spinner fa-spin"></i> Downloading…</>
                  : <><i className="fas fa-download"></i> Download PPSR PDF</>}
              </button>
              <button className="btn btn-secondary" onClick={handlePrint}>
                <i className="fas fa-print"></i> Print Certificate Report
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Report Preview */}
      <section className="report-preview-section">
        <div className="container">
          <div className="report-preview">
            <div className="ppsr-certificate">

              {/* Certificate Header */}
              <div className="certificate-header">
                <div className="certificate-logo">
                  <i className="fas fa-shield-alt"></i>
                  <div>
                    <h2>PPSR Certificate - {order.reportType == 'comprehensive' ? 'Comprehensive' : 'Basic'}</h2>
                    <p>Personal Property Securities Register</p>
                  </div>
                </div>
                <div className="certificate-badge">
                  <i className="fas fa-certificate"></i>
                  <span>Official Document</span>
                </div>
              </div>

              {/* Vehicle Summary */}
              <div className="report-section">
                <h3 className="report-section-title">
                  <i className="fas fa-car"></i> Vehicle Summary
                </h3>
                <div className="info-grid">
                  {[
                    { label: 'Registration',  value: order.plate },
                    { label: 'State',         value: order.state },
                    { label: 'VIN',           value: fmt(order?.reportData?.result?.vehicle?.identification?.vin    || vehicle.VIN) },
                    { label: 'Year',          value: fmt(order?.reportData?.result?.vehicle?.details?.year   || vehicle.buildYear) },
                    { label: 'Make',          value: fmt(order?.reportData?.result?.vehicle?.details?.make  || vehicle.manufacturerName) },
                    { label: 'Model',         value: fmt(order?.reportData?.result?.vehicle?.details?.model || vehicle.modelName) },
                    { label: 'Body Type',     value: fmt(order?.reportData?.result?.vehicle?.details?.bodyType || vehicle.bodyType) },
                    { label: 'Colour',        value: fmt(order?.reportData?.result?.vehicle?.details?.colour || vehicle.color || vehicle.primaryColour) },
                  ].map(({ label, value }) => (
                    <div className="info-item" key={label}>
                      <span className="info-label">{label}</span>
                      <span className="info-value">{value}</span>
                    </div>
                  ))}
                  {order.reportType === 'comprehensive' ? (
                    [
                    { label: 'Compliance Plate',  value: order?.reportData?.result?.vehicle?.details?.compliancePlate || '' },
                    { label: 'Fuel Type',         value: order?.reportData?.result?.vehicle?.details?.fuelType || '' },
                    { label: 'ccRating',          value: fmt(order?.reportData?.result?.vehicle?.details?.ccRating || '') },
                    { label: 'Engine Number',          value: fmt(order?.reportData?.result?.vehicle?.details?.engineNumber || '') },
                    { label: 'Engine Type',         value: order?.reportData?.result?.vehicle?.details?.engineType || '' },
                    { label: 'Engine Description',         value: fmt(order?.reportData?.result?.vehicle?.details?.engineDescription ||'') },
                    { label: 'Power (kW)',     value: fmt(order?.reportData?.result?.vehicle?.details?.powerKw || ''  ) },
                    { label: 'Power Description',        value: fmt(order?.reportData?.result?.vehicle?.details?.powerDescription || '' ) },
                    { label: 'Weight',        value: fmt(order?.reportData?.result?.vehicle?.details?.weight || '' ) },
                    { label: 'Power to Weight',        value: fmt(order?.reportData?.result?.vehicle?.details?.powerToWeight || '' ) },
                    { label: 'Cylinders',        value: fmt(order?.reportData?.result?.vehicle?.details?.cylinders || '' ) },
                    { label: 'Drive Type',        value: fmt(order?.reportData?.result?.vehicle?.details?.driveType || '' ) },
                    { label: 'Doors',        value: fmt(order?.reportData?.result?.vehicle?.details?.doors || '' ) },
                    { label: 'Country of Origin',        value: fmt(order?.reportData?.result?.vehicle?.details?.countryOfOrigin || '' ) },
                    { label: 'Built Start Month',        value: fmt(order?.reportData?.result?.vehicle?.details?.builtStartMonth || '' ) },
                    { label: 'Built Start Year',        value: fmt(order?.reportData?.result?.vehicle?.details?.builtStartYear || '' ) },
                    { label: 'Built End Month',        value: fmt(order?.reportData?.result?.vehicle?.details?.builtEndMonth || '' ) },
                    { label: 'Built End Year',        value: fmt(order?.reportData?.result?.vehicle?.details?.builtEndYear || '' ) },
                  ].map(({ label, value }) => (
                    <div className="info-item" key={label}>
                      <span className="info-label">{label}</span>
                      <span className="info-value">{value}</span>
                    </div>
                  ))
                  ) : null}
                </div>
              </div>

              {/* PPSR Results */}
              <div className="report-section">
                <h3 className="report-section-title">
                  <i className="fas fa-search"></i> PPSR Check Results
                </h3>
                <div className="check-results">
                  <CheckResult
                    label="Finance Check"
                    status={order?.reportData?.result?.vehicle?.ppsrSearchResult?.securityInterests?.length > 0 || ppsr.securityInterest ? 'FAIL' : 'CLEAR'}
                    detail={order?.reportData?.result?.vehicle?.ppsrSearchResult?.securityInterests?.length > 0 || (ppsr.securityInterest ? 'Security interest registered' : 'No security interests or money owing found on this vehicle')}
                  />
                  {order.reportType === 'comprehensive' ? (
                  <CheckResult
                    label="Stolen Vehicle Check"
                    status={order?.reportData?.result?.vehicle?.stolenInfo?.incidents?.length > 0 || ppsr.isStolen ? 'FAIL' : 'CLEAR'}
                    detail={order?.reportData?.result?.vehicle?.stolenInfo?.incidents?.length > 0 || (ppsr.isStolen ? 'Vehicle reported as stolen' : 'This vehicle has not been reported as stolen')}
                  />
                  ) : (
                  <CheckResult
                    label="Stolen Vehicle Check"
                    status={order?.reportData?.result?.vehicle?.stolenIncidents?.length > 0 || ppsr.isStolen ? 'FAIL' : 'CLEAR'}
                    detail={order?.reportData?.result?.vehicle?.stolenIncidents?.length > 0 || (ppsr.isStolen ? 'Vehicle reported as stolen' : 'This vehicle has not been reported as stolen')}
                  />
                  )}
                  {order.reportType === 'comprehensive' ? (
                  <CheckResult
                    label="Written Off Check"
                    status={order?.reportData?.result?.vehicle?.writtenOffInfo?.incidents?.length > 0 || ppsr.isWrittenOff ? 'FAIL' : 'CLEAR'}
                    detail={order?.reportData?.result?.vehicle?.writtenOffInfo?.incidents?.length > 0 || (ppsr.isWrittenOff ? 'Vehicle has been written off' : 'No written-off records found for this vehicle')}
                  />
                  ) : (
                  <CheckResult
                    label="Written Off Check"
                    status={order?.reportData?.result?.vehicle?.writtenOffIncidents?.length > 0 || ppsr.isWrittenOff ? 'FAIL' : 'CLEAR'}
                    detail={order?.reportData?.result?.vehicle?.writtenOffIncidents?.length > 0 || (ppsr.isWrittenOff ? 'Vehicle has been written off' : 'No written-off records found for this vehicle')}
                  />
                  )}
                </div>
              </div>

              {/* Registration Details */}
              <div className="report-section">
                <h3 className="report-section-title">
                  <i className="fas fa-id-card"></i> Registration Details
                </h3>
                <div className="info-grid">
                  {[
                    { label: 'Registration Status', value: fmt(order?.reportData?.result?.vehicle?.registration?.status || rego.registrationStatus), className: (order?.reportData?.result?.vehicle?.registration?.status === 'REGISTERED' ? 'status-active' : 'status-danger') },
                    { label: 'Expiry Date',          value: fmt(rego.expiryDate || rego.expiry) },
                    { label: 'First Registered',     value: fmt(compliancedate || rego.firstRegistrationDate) },
                    { label: 'Last Updated',         value: `${dateStr} ${timeStr}` },
                  ].map(({ label, value, className }) => (
                    <div className="info-item" key={label}>
                      <span className="info-label">{label}</span>
                      <span className={`info-value${className ? ` ${className}` : ''}`}>{value}</span>
                    </div>
                  ))}
                </div>
              </div>


              {/* Written Off Details */}
              <div className="report-section">
                <h3 className="report-section-title">
                  <i className="fas fa-search"></i> Written Off Details
                </h3>
                <div className="check-results">
                  {order.reportType === 'comprehensive' ? (
                  <>
                    {order?.reportData?.result?.vehicle?.writtenOffInfo?.incidents?.map(({ typeCode, jurisdiction, recordDate, incidentCode, damageCodes }, index) => (
                  <CheckResult 
                    label={`Written Off Details ${index + 1} - ${typeCode} in ${jurisdiction} on ${new Date(recordDate).toLocaleDateString()}. Incident Result: ${incidentCode}`}
                    status='FAIL'
                    detail={`Damage Codes: ${damageCodes}`}
                  />
                  ))}
                  </>
                  ) : (
                  <>
                    {order?.reportData?.result?.vehicle?.writtenOffIncidents?.map((writeoffincident, index) => (
                  <CheckResult 
                    label={`Written Off Details ${index + 1} - ${writeoffincident}`}
                    status='FAIL'
                    detail=''
                  />
                  ))}
                  </>
                  )}
                </div>
              </div>


              {/* Stolen Off Details */}
              <div className="report-section">
                <h3 className="report-section-title">
                  <i className="fas fa-search"></i> Stolen Details
                </h3>
                <div className="check-results">
                  {order.reportType === 'comprehensive' ? (
                  <>
                    {order?.reportData?.result?.vehicle?.stolenInfo?.incidents?.map(({ incidentType, jurisdiction, reportedDate, summary }, index) => (
                  <CheckResult 
                    label={`Stolen Details ${index + 1} - ${incidentType} in ${jurisdiction} on ${new Date(reportedDate).toLocaleDateString()}. Summary: ${summary}`}
                    status='FAIL'
                    detail=''
                  />
                  ))}
                  </>
                  ) : (
                  <>
                    {order?.reportData?.result?.vehicle?.stolenIncidents?.map((stolenincident, index) => (
                  <CheckResult 
                    label={`Stolen Details ${index + 1} - ${stolenincident}`}
                    status='FAIL'
                    detail=''
                  />
                  ))}
                  </>
                  )}
                </div>
              </div>


              {/*  Security Interest Details */}
                
                <div className="report-section">
                  <h3 className="report-section-title">
                    <i className="fas fa-tachometer-alt"></i> Security Interest Details
                  </h3>
                  {order?.reportData?.result?.vehicle?.ppsrSearchResult?.securityInterests?.length > 0 ? (
                    <>
                      <div className="odometer-table">
                        <table>
                          <thead>
                            <tr><th>Security Interest Details</th></tr>
                          </thead>
                          <tbody>
                            {order?.reportData?.result?.vehicle?.ppsrSearchResult?.securityInterests?.map(({ registrationNumber, registrationKind, startDate, endDate}, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="info-item-custom" key={index}>
                                      <CheckResult 
                                      label={` Security Interest Details ${index + 1}`}
                                      status='FAIL'
                                      detail={`registrationNumber: ${registrationNumber}, registrationKind: (${registrationKind}) from ${startDate === null ? 'N/A' : new Date(startDate).toLocaleDateString()} to ${endDate === null ? 'N/A' :   new Date(endDate).toLocaleDateString()}`}
                                      />
                                  </div>                                         
                                  <div className="info-item-custom" key={index}>
                                      <span className="info-label">Address For Service</span>
                                      <span>{`Addressee: `}<strong>{`${order?.reportData?.result?.vehicle?.ppsrSearchResult?.securityInterests?.[index]?.addressForService?.addressee || 'N/A'}`}</strong><br />{`email: `}<strong>{order?.reportData?.result?.vehicle?.ppsrSearchResult?.securityInterests?.[index]?.addressForService?.email || 'N/A'}</strong></span>
                                  </div>
                                  <div className="info-item-custom" key={index}>
                                      <span className="info-label">Mailing Address</span>
                                      <span><strong>{`${order?.reportData?.result?.vehicle?.ppsrSearchResult?.securityInterests?.[index]?.addressForService?.mailingAddress?.formatted || 'N/A'}`}</strong></span>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  ) : (
                    <p className="no-data">No security interest records available for this vehicle.</p>
                  )}
                </div>
                

              {/*  Security Interest Details */}
                {/*
                <div className="report-section">
                  <h3 className="report-section-title">
                    <i className="fas fa-tachometer-alt"></i> Security Interest Details
                  </h3>
                  {order?.reportData?.result?.vehicle?.ppsrSearchResult?.securityInterests?.length > 0 ? (
                    <>
                      <div className="odometer-table">
                        <table>
                          <thead>
                            <tr><th>Security Interest Details</th><th>Address For Service</th><th>mailingAddress</th></tr>
                          </thead>
                          <tbody>
                            {order?.reportData?.result?.vehicle?.ppsrSearchResult?.securityInterests?.map(({ registrationNumber, registrationKind, startDate, endDate}, index) => (
                              <tr key={index}>
                                <td><div className="info-item" key={index}>
                                      <CheckResult 
                                      label={` Security Interest Details ${index + 1}`}
                                      status='FAIL'
                                      detail={`registrationNumber: ${registrationNumber}, registrationKind: (${registrationKind}) from ${startDate === null ? 'N/A' : new Date(startDate).toLocaleDateString()} to ${endDate === null ? 'N/A' :   new Date(endDate).toLocaleDateString()}`}
                                      />
                                  </div>         
                                </td>
                                <td><div className="info-item" key={index}>
                                      <span className="info-label">Address For Service</span>
                                      <span>{`Addressee: `}<strong>{`${order?.reportData?.result?.vehicle?.ppsrSearchResult?.securityInterests?.[index]?.addressForService?.addressee || 'N/A'}`}</strong><br />{`email: `}<strong>{order?.reportData?.result?.vehicle?.ppsrSearchResult?.securityInterests?.[index]?.addressForService?.email || 'N/A'}</strong></span>
                                  </div>
                                </td>
                                <td><div className="info-item" key={index}>
                                      <span className="info-label">Mailing Address</span>
                                      <span><strong>{`${order?.reportData?.result?.vehicle?.ppsrSearchResult?.securityInterests?.[index]?.addressForService?.mailingAddress?.formatted || 'N/A'}`}</strong></span>
                                    </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  ) : (
                    <p className="no-data">No security interest records available for this vehicle.</p>
                  )}
                </div>
                */}



              {/* Odometer History (Comprehensive only) */}
              {order.reportType === 'comprehensive' && (
                <div className="report-section">
                  <h3 className="report-section-title">
                    <i className="fas fa-tachometer-alt"></i> Odometer History
                  </h3>
                  {(reportData?.odometer?.readings || []).length > 0 ? (
                    <>
                      <div className="odometer-table">
                        <table>
                          <thead>
                            <tr><th>Date</th><th>Reading (km)</th><th>Source</th></tr>
                          </thead>
                          <tbody>
                            {reportData.odometer.readings.map((r, i) => (
                              <tr key={i}>
                                <td>{fmt(r.date)}</td>
                                <td>{r.reading ? r.reading.toLocaleString() : '—'}</td>
                                <td>{fmt(r.source)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      <div className="odometer-status">
                        <i className="fas fa-check-circle"></i>
                        <span>{reportData.odometer?.status || 'Odometer readings appear consistent'}</span>
                      </div>
                    </>
                  ) : (
                    <p className="no-data">No odometer records available for this vehicle.</p>
                  )}
                </div>
              )}

              {/* Certificate Footer */}
              <div className="certificate-footer">
                <div className="certificate-disclaimer">
                  <h4><i className="fas fa-info-circle"></i> Important Information</h4>
                  <p>This PPSR certificate is generated from data held on the Personal Property Securities Register at the time of the search. While every effort is made to ensure accuracy, checkmycarhistory.com.au accepts no liability for errors or omissions. This report should be used as a guide only and does not constitute legal advice.</p>
                </div>
                <div className="certificate-verification">
                  <div className="verification-item">
                    <strong>Certificate ID:</strong> <span>CERT-{order.orderId?.substring(0, 12).toUpperCase()}</span>
                  </div>
                  <div className="verification-item">
                    <strong>Generated:</strong> <span>{dateStr} at {timeStr}</span>
                  </div>
                  <div className="verification-item">
                    <strong>Valid for:</strong> <span>This search only</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Actions */}
      <section className="additional-actions">
        <div className="container">
          <div className="action-cards">
            <div className="action-card">
              <div className="action-icon"><i className="fas fa-search"></i></div>
              <h3>Check Another Vehicle</h3>
              <p>Need to check another vehicle? Start a new search now.</p>
              <Link to="/" className="btn btn-secondary">New Search</Link>
            </div>
            <div className="action-card">
              <div className="action-icon"><i className="fas fa-question-circle"></i></div>
              <h3>Need Help?</h3>
              <p>Have questions about your report? We're here to help.</p>
              <Link to="/help" className="btn btn-secondary">View FAQ</Link>
            </div>
            <div className="action-card">
              <div className="action-icon"><i className="fas fa-phone"></i></div>
              <h3>Contact Support</h3>
              <p>Get in touch with our support team for assistance.</p>
              <Link to="/contact" className="btn btn-secondary">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
